import dayjs from 'dayjs';

export const formatLocalDate = (value: string) => {
  if (!value) return '';
  return dayjs(value).local().format('L');
};
